import { useSubmitByEnter } from '@libs/hooks';
import { selectStatus, selectSubmitWidget, useAppSelector } from '@libs/store';
import React from 'react';
import PageWrapperStyled from './PageWrapperStyled';

export const PageWrapper = ({ children }: { children: React.ReactNode }) => {
    const submitWidget = useAppSelector(selectSubmitWidget);
    const status = useAppSelector(selectStatus);
    const handleKeyDown = useSubmitByEnter(submitWidget);

    return (
        <PageWrapperStyled onKeyDown={handleKeyDown} $status={status}>
            {children}
        </PageWrapperStyled>
    );
};
